function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.0039 8.75V13.75L17.2839 15.04C17.9139 15.67 17.4639 16.75 16.5739 16.75H3.40388C2.51388 16.75 2.07388 15.67 2.70388 15.04L4.00388 13.75V8.75C4.00388 5.67 5.63388 3.11 8.50388 2.43V1.75C8.50388 0.92 9.16388 0.25 9.99388 0.25C10.8239 0.25 11.5039 0.92 11.5039 1.75V2.43C14.3639 3.11 16.0039 5.68 16.0039 8.75ZM11.9939 17.75C11.9939 18.85 11.0939 19.75 9.99388 19.75C8.88388 19.75 7.99388 18.85 7.99388 17.75H11.9939ZM4.77388 2.48C5.19388 2.1 5.20388 1.45 4.80388 1.05C4.42388 0.67 3.80388 0.66 3.41388 1.03C1.70388 2.59 0.523883 4.71 0.143883 7.09C0.0538834 7.7 0.523883 8.25 1.14388 8.25C1.62388 8.25 2.04388 7.9 2.12388 7.42C2.42388 5.48 3.38388 3.75 4.77388 2.48ZM15.2039 1.05C15.5839 0.67 16.2039 0.66 16.6039 1.03C18.3039 2.6 19.4739 4.71 19.8539 7.08C19.9539 7.69 19.4739 8.24 18.8639 8.24C18.3739 8.24 17.9539 7.89 17.8839 7.41C17.5839 5.47 16.6139 3.74 15.2339 2.47C14.8239 2.09 14.8039 1.45 15.2039 1.05Z",
  fill: "black",
  fillOpacity: 0.54
});

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.15f71829.svg";
export { ForwardRef as ReactComponent };